import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../utils/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import VerticalSpace from "../VerticalSpace";
import Label from "../Common/Label";
import { baseURL, getRequest, postRequest } from "../../api/apiClient";
import gsap from "gsap";
import "../../stylesheets/common.css";
import Toast from "../Common/Toast";
import Switch from "../Common/Switch";
import CustomCheckbox from "../Common/CustomCheckbox";
interface VersionChecker {
  android: {
    isforce_update: boolean;
    version_code: number;
    build: string;
  };
  ios: {
    isforce_update: boolean;
    version_code: number;
    build: string;
    isAppInReview:boolean;
    inReviewVersion:number;
  };
}

interface AppSupport {
  id: number;
  supportEmail: string;
  userDateDonwloadPolicyUrl: string;
  faqUrl: string;
  privacyPocilyUrl: string;
  stripeKey: string;
  termsAndConditionsUrl: string;
  version_checker: VersionChecker;
  isVerified:boolean
  updatedAt: string;
}

const CreateAppSupport = () => {
  const [appSupport, setAppSupport] = useState<AppSupport>();
  console.log('appSupport: ', appSupport);
  const [loading, setLoading] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAppSupportById();
  }, []);

  useEffect(() => {
    if (textareaRef.current && appSupport?.stripeKey) {
      // Auto resize textarea based on content
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [appSupport?.stripeKey]);

  const fetchAppSupportById = async () => {
    setLoading(true);
    const response = await getRequest(`${baseURL}/get-app-support`);
    if (response?.data?.success) {
      setAppSupport(response.data.data[0]);
    }
    setLoading(false);
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setAppSupport((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleVersionChange = (
    platform: "android" | "ios",
    field: keyof VersionChecker["android"] | keyof VersionChecker["ios"],
    value: string | boolean | number
  ) => {
    setAppSupport((prev: any) => ({
      ...prev,
      version_checker: {
        ...prev.version_checker,
        [platform]: {
          ...prev.version_checker?.[platform],
          [field]: value,
        },
      },
    }));
  };

  const isValidVersionData = () => {
    const android = appSupport?.version_checker?.android;
    const ios = appSupport?.version_checker?.ios;

    // Helper functions for validation
    const isNonEmptyString = (value: any) =>
      typeof value === "string" && value.trim() !== "";

    const isValidNumber = (value: any) =>
      typeof value === "number" && !isNaN(value) && value >= 0;

    const errors: string[] = [];

    // Android validation
    if (!isNonEmptyString(android?.build)) {
      errors.push("Android Build Version is required.");
    }
    if (!isValidNumber(android?.version_code)) {
      errors.push("Android Version Code must be a valid non-negative number.");
    }

    // iOS validation
    if (!isNonEmptyString(ios?.build)) {
      errors.push("ios Build Version is required.");
    }
    if (!isValidNumber(ios?.version_code)) {
      errors.push("ios Version Code must be a valid non-negative number.");
    }
    if (!isNonEmptyString(ios?.inReviewVersion)) {
      errors.push("ios in review version must be a valid non-negative number.");
    }

    return { valid: errors.length === 0, errors };
  };

  const handleSubmit = async () => {
    const { valid, errors } = isValidVersionData();


    if (!valid) {
      Toast(errors[0], "error");
      return;
    }
    setLoading(true);
    const updatedAppSupport = {
      ...appSupport,
      isVerified: appSupport?.version_checker?.ios?.isAppInReview ?? false,
    };
    const response = await postRequest(
      `${baseURL}/create-update-appsupport`,
      updatedAppSupport
    );
    if (response?.data?.success) {
      setAppSupport(response?.data?.data);
      Toast(response.data.statusMessage, "success");
      setLoading(false);
    }
    setLoading(false);
  };

  const handleBackClick = () => {
    navigate("/app-supports");
  };

  useEffect(() => {
    let timeLine = gsap.timeline();
    timeLine.from(".row-container", {
      opacity: 0,
      y: -40,
      duration: 1,
      ease: "power2.out",
    });
  }, [loading]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="container-fluid">
          <div className="p-3 main-page">
            <div
              className="d-flex  align-items-center go-back"
              onClick={handleBackClick}
              style={{ width: "fit-content" }}
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="me-2"
                style={{
                  backgroundColor: "#D9D9D9",
                  padding: "7px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  color: "#000",
                }}
              />
              <label
                style={{
                  color: "#FF9E00",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Back
              </label>
            </div>
            <h4
              className="row-container"
              style={{
                textAlign: "center",
                margin: "auto",
                color: "#7542E4",
                fontWeight: "bold",
              }}
            >
              App Support
            </h4>
            <VerticalSpace height={20} />
            <div className="row p-3 d-flex align-items-center justify-content-center">
              <div
                className="container col-10"
                style={{
                  backgroundColor: "rgb(220 220 220 / 66%)",
                  borderRadius: "30px",
                  padding: "20px",
                }}
              >
                <VerticalSpace height={24} />
                <div className="col">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <Label
                        fontSize="14px"
                        padding="0px 0px 0px 8px"
                        fontWeight={400}
                      >
                        Support email
                      </Label>
                      <VerticalSpace height={4} />
                      <input
                        type="text"
                        className="form-control"
                        name="supportEmail"
                        value={appSupport?.supportEmail || ""}
                        onChange={handleInputChange}
                        style={{
                          borderRadius: "10px",
                          height: "40px",
                          fontSize: "14px",
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <Label
                        fontSize="14px"
                        padding="0px 0px 0px 8px"
                        fontWeight={400}
                      >
                        User Data Download Policy URL
                      </Label>
                      <VerticalSpace height={4} />
                      <input
                        type="text"
                        className="form-control"
                        name="userDateDonwloadPolicyUrl"
                        value={appSupport?.userDateDonwloadPolicyUrl || ""}
                        onChange={handleInputChange}
                        style={{
                          borderRadius: "10px",
                          height: "40px",
                          fontSize: "14px",
                        }}
                      />
                    </div>
                    <br />
                    <div className="col-md-6">
                      <Label
                        fontSize="14px"
                        padding="0px 0px 0px 8px"
                        fontWeight={400}
                      >
                        FAQ URL
                      </Label>
                      <VerticalSpace height={4} />
                      <input
                        type="text"
                        className="form-control"
                        name="faqUrl"
                        value={appSupport?.faqUrl || ""}
                        onChange={handleInputChange}
                        style={{
                          borderRadius: "10px",
                          height: "40px",
                          fontSize: "14px",
                        }}
                      />
                    </div>
                    <br />
                    <div className="col-md-6">
                      <Label
                        fontSize="14px"
                        padding="0px 0px 0px 8px"
                        fontWeight={400}
                      >
                        Privacy Policy URL
                      </Label>
                      <VerticalSpace height={4} />
                      <input
                        type="text"
                        className="form-control"
                        name="privacyPocilyUrl"
                        value={appSupport?.privacyPocilyUrl || ""}
                        onChange={handleInputChange}
                        style={{
                          borderRadius: "10px",
                          height: "40px",
                          fontSize: "14px",
                        }}
                      />
                    </div>
                    <br />
                    <div className="col-12">
                      <Label
                        fontSize="14px"
                        padding="0px 0px 0px 8px"
                        fontWeight={400}
                      >
                        Terms And Conditions Url
                      </Label>
                      <VerticalSpace height={4} />
                      <input
                        type="text"
                        className="form-control"
                        name="termsAndConditionsUrl"
                        value={appSupport?.termsAndConditionsUrl || ""}
                        onChange={handleInputChange}
                        style={{
                          borderRadius: "10px",
                          height: "40px",
                          fontSize: "14px",
                        }}
                      />
                    </div>
                    <br />
                    <div className="col-12">
                      <Label
                        fontSize="14px"
                        padding="0px 0px 0px 8px"
                        fontWeight={400}
                      >
                        Stripe Key
                      </Label>
                      <VerticalSpace height={4} />
                      <textarea
                        ref={textareaRef}
                        name="stripeKey"
                        className="form-control"
                        data-kt-autosize="true"
                        value={appSupport?.stripeKey || ""}
                        onChange={handleInputChange}
                        style={{
                          resize: "none",
                          overflow: "hidden",
                        }}
                      />
                    </div>
                    <br />
                    {/* Android Version Settings */}
                    <div className="row mt-2">
                      <div className="col-12 mb-2">
                        <Label fontSize="16px" fontWeight={400}>
                          Android Version Settings
                        </Label>
                      </div>

                      <div className="col-md-4">
                        <Label
                          fontSize="14px"
                          padding="0px 0px 0px 8px"
                          fontWeight={400}
                        >
                          Build Version
                        </Label>
                        <VerticalSpace height={4} />
                        <input
                          type="text"
                          className="form-control"
                          name="androidBuild"
                          value={
                            appSupport?.version_checker?.android.build ?? ""
                          }
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow empty string, numbers, and decimal points
                            if (value === '' || /^\d*\.?\d*$/.test(value)) {
                              handleVersionChange(
                                "android",
                                "build",
                                value
                              );
                            }
                          }}
                          style={{
                            borderRadius: "10px",
                            height: "40px",
                            fontSize: "14px",
                          }}
                        />
                      </div>

                      <div className="col-md-4">
                        <Label
                          fontSize="14px"
                          padding="0px 0px 0px 8px"
                          fontWeight={400}
                        >
                          Version Code
                        </Label>
                        <VerticalSpace height={4} />
                        <input
                          type="text"
                          className="form-control"
                          name="androidVersionCode"
                          value={
                            appSupport?.version_checker?.android.version_code ??
                            ''
                          }
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow empty string, numbers, and decimal points
                            if (value === '' || /^\d*\.?\d*$/.test(value)) {
                              // Store raw value to preserve partial decimals like "1."
                              const numValue = value === '' ? '' : 
                                               (value.endsWith('.') || value === '.' ? value : 
                                               (parseFloat(value) || 0));
                              handleVersionChange(
                                "android",
                                "version_code",
                                numValue
                              );
                            }
                          }}
                          style={{
                            borderRadius: "10px",
                            height: "40px",
                            fontSize: "14px",
                          }}
                        />
                      </div>

                      <div className="col-md-4 d-flex flex-column justify-content-center">
                        <Label
                          fontSize="14px"
                          padding="0px 0px 0px 8px"
                          fontWeight={400}
                        >
                          Force Update
                        </Label>
                        <VerticalSpace height={4} />
                        <CustomCheckbox
                          checked={
                            appSupport?.version_checker?.android
                              ?.isforce_update || false
                          }
                          onChange={() =>
                            handleVersionChange(
                              "android",
                              "isforce_update",
                              !appSupport?.version_checker?.android
                                ?.isforce_update
                            )
                          }
                        />
                      </div>
                    </div>
                    <br />
                    {/* iOS Version Settings */}
                    <div className="row mt-2">
                      <div className="col-12 mb-2">
                        <Label fontSize="16px" fontWeight={400}>
                          ios Version Settings
                        </Label>
                      </div>

                      <div className="col-md-4">
                        <Label
                          fontSize="14px"
                          padding="0px 0px 0px 8px"
                          fontWeight={400}
                        >
                          Build Version
                        </Label>
                        <VerticalSpace height={4} />
                        <input
                          type="text"
                          className="form-control"
                          name="iosBuild"
                          value={appSupport?.version_checker?.ios.build ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow empty string, numbers, and decimal points
                            if (value === '' || /^\d*\.?\d*$/.test(value)) {
                              handleVersionChange("ios", "build", value);
                            }
                          }}
                          style={{
                            borderRadius: "10px",
                            height: "40px",
                            fontSize: "14px",
                          }}
                        />
                      </div>

                      <div className="col-md-4">
                        <Label
                          fontSize="14px"
                          padding="0px 0px 0px 8px"
                          fontWeight={400}
                        >
                          Version Code
                        </Label>
                        <VerticalSpace height={4} />
                        <input
                          type="text"
                          className="form-control"
                          name="iosVersionCode"
                          value={
                            appSupport?.version_checker?.ios.version_code ??
                            ''
                          }
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow empty string, numbers, and decimal points
                            if (value === '' || /^\d*\.?\d*$/.test(value)) {
                              // Store raw value to preserve partial decimals like "1."
                              const numValue = value === '' ? '' : 
                                               (value.endsWith('.') || value === '.' ? value : 
                                               (parseFloat(value) || 0));
                              handleVersionChange(
                                "ios",
                                "version_code",
                                numValue
                              );
                            }
                          }}
                          style={{
                            borderRadius: "10px",
                            height: "40px",
                            fontSize: "14px",
                          }}
                        />
                      </div>

                      <div className="col-md-4 d-flex flex-column justify-content-center">
                        <Label
                          fontSize="14px"
                          padding="0px 0px 0px 8px"
                          fontWeight={400}
                        >
                          Force Update
                        </Label>
                        <VerticalSpace height={4} />
                        <CustomCheckbox
                          checked={
                            appSupport?.version_checker?.ios?.isforce_update ||
                            false
                          }
                          onChange={() =>
                            handleVersionChange(
                              "ios",
                              "isforce_update",
                              !appSupport?.version_checker?.ios?.isforce_update
                            )
                          }
                        />
                      </div>

                      <div className="col-md-8">
                        <Label
                          fontSize="14px"
                          padding="0px 0px 0px 8px"
                          fontWeight={400}
                        >
                          Review Version
                        </Label>
                        <VerticalSpace height={4} />
                        <input
                          type="text"
                          className="form-control"
                          name="iosBuild"
                          value={appSupport?.version_checker?.ios?.inReviewVersion || ""}
                          onChange={(e) =>
                            handleVersionChange("ios", "inReviewVersion", e.target.value)
                          }
                          style={{
                            borderRadius: "10px",
                            height: "40px",
                            fontSize: "14px",
                          }}
                        />
                      </div>

                      <div className="col-md-4 d-flex flex-column justify-content-center">
                        <Label
                          fontSize="14px"
                          padding="0px 0px 0px 8px"
                          fontWeight={400}
                        >
                          isAppInReview
                        </Label>
                        <VerticalSpace height={4} />
                        <CustomCheckbox
                          checked={
                            appSupport?.version_checker?.ios?.isAppInReview ||
                            false
                          }
                          onChange={() =>
                            handleVersionChange(
                              "ios",
                              "isAppInReview",
                              !appSupport?.version_checker?.ios?.isAppInReview
                            )
                          }
                        />
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <VerticalSpace height={100} />
            <div
              className="container row d-flex justify-content-center publish-button"
              style={{
                position: "fixed",
                zIndex: 1,
                height: "12%",
                maxWidth: "100%",
                bottom: "0px",
                background:
                  "linear-gradient(178.35deg, rgba(255, 255, 255, 0) 1.4%, rgba(255, 255, 255, 0.69) 26.79%, #FFFFFF 50.22%)",
              }}
            >
              <div
                className="d-flex justify-content-center"
                style={{
                  position: "fixed",
                  zIndex: 1,
                  bottom: "34px",
                }}
              >
                <button
                  type="button"
                  className="btn btn-success d-flex justify-content-center user"
                  style={{
                    backgroundColor: "#FF9E00",
                    color: "#100F15",
                    height: "fit-content",
                    borderRadius: "10px",
                    padding: "10px 20%",
                    width: "400px",
                    fontSize: "14px",
                  }}
                  onClick={handleSubmit}
                >
                  Publish
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default CreateAppSupport;
